import React, { useState } from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";
import { http, formatError } from "@/lib/api";

export default function Contact() {
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", college: "", message: "" });

  function upd(k, v) { setForm((f) => ({ ...f, [k]: v })); }

  async function onSubmit(e) {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    try {
      await http.post("/contact", form);
      setSent(true);
      toast.success("Got it! We'll be in touch within 24 hours.");
      setForm({ name: "", email: "", college: "", message: "" });
    } catch (err) {
      const detail = formatError(err.response?.data?.detail) || err.message || "Message could not be sent";
      toast.error(`Sorry — ${detail}. Please email us at hello@quadscrub.com.`);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="max-w-5xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-10">
      <div>
        <Badge variant="outline" className="mb-3">Contact</Badge>
        <h1 className="font-display text-4xl font-bold text-primary">Tell us about your student's place.</h1>
        <p className="mt-3 text-muted-foreground">We answer every message within one business day.</p>
        <div className="mt-8 space-y-4 text-sm">
          <div className="flex items-center gap-3"><Mail className="text-secondary" size={18} /> hello@quadscrub.com</div>
          <div className="flex items-center gap-3"><Phone className="text-secondary" size={18} /> 1-877-424-1662</div>
          <div className="flex items-center gap-3"><MapPin className="text-secondary" size={18} /> Serving 60+ college towns nationwide</div>
        </div>
      </div>
      <form onSubmit={onSubmit} className="bg-muted/30 border border-border/60 rounded-2xl p-6 space-y-4">
        <Input placeholder="Your name" required value={form.name} onChange={(e) => upd("name", e.target.value)} data-testid="contact-name" />
        <Input type="email" placeholder="Email" required value={form.email} onChange={(e) => upd("email", e.target.value)} data-testid="contact-email" />
        <Input placeholder="Student's college / city" value={form.college} onChange={(e) => upd("college", e.target.value)} data-testid="contact-college" />
        <Textarea placeholder="What can we help with?" rows={5} required value={form.message} onChange={(e) => upd("message", e.target.value)} data-testid="contact-message" />
        <Button className="w-full bg-primary hover:bg-primary/90" type="submit" disabled={busy} data-testid="contact-submit">
          {busy ? "Sending…" : sent ? "Sent ✓" : "Send message"}
        </Button>
      </form>
    </div>
  );
}
